import type { Error as ApiError } from '../api/schema'

// Type guard to check if an error is an API error (has title property)
export function isApiError(error: unknown): error is ApiError {
  return typeof error === 'object' && error !== null && 'title' in error && typeof (error as any).title === 'string'
}

// Type guard to check if an error is a JavaScript Error (has message property)
export function isJavaScriptError(error: unknown): error is Error {
  return error instanceof Error || (typeof error === 'object' && error !== null && 'message' in error && typeof (error as any).message === 'string')
}

// Get a user-friendly error message from any error type
export function getErrorMessage(error: unknown): string {
  if (isApiError(error)) {
    return error.title || 'An error occurred'
  }
  
  if (isJavaScriptError(error)) {
    return error.message || 'An error occurred'
  }
  
  if (typeof error === 'string') {
    return error
  }
  
  return 'An unknown error occurred'
}

// Get a detailed error message from any error type (includes both title and detail for API errors)
export function getDetailedErrorMessage(error: unknown): string {
  if (isApiError(error)) {
    const title = error.title || 'An error occurred'
    const detail = error.detail
    return detail ? `${title}: ${detail}` : title
  }
  
  return getErrorMessage(error)
}